import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingWizard from "@/components/OnboardingWizard";

function OnboardingPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user has a valid auth token
    const token = localStorage.getItem("shopglobal_auth_token");
    if (!token) {
      navigate("/login");
      return;
    }

    // If we have a token, we're good to proceed with onboarding
    setIsLoading(false);
  }, [navigate]);

  const handleOnboardingComplete = () => {
    // Navigate to dashboard after onboarding is complete
    navigate("/dashboard");
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Welcome to ShopGlobal Pro!
          </h1>
          <p className="text-lg text-gray-600">
            Let's get you set up with your international shopping experience
          </p>
        </div>

        <OnboardingWizard onComplete={handleOnboardingComplete} />
      </div>
    </div>
  );
}

export default OnboardingPage;
